import { ReactNode, useEffect } from 'react';

import { useRightPanelContext } from '../context/RightPanelContext';

const useSetRightPanelContent = (content: ReactNode | null) => {
    const { setRightPanelContent } = useRightPanelContext();

    useEffect(() => {
        setRightPanelContent(content);
        return () => setRightPanelContent(null);
    }, [content, setRightPanelContent]);
};

export default useSetRightPanelContent;
